import { createStyles } from '@material-ui/styles';
import palette from 'theme/palette';

export default () =>
  createStyles({
    title: { fontSize: 14, color: palette.darkGray, fontWeight: 'bold' },
    value: { fontSize: 12 },
    summaryData: { display: 'grid', marginBottom: 15 },
  });
